import { PlaygroundEmployeeTestActivityDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { Activity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

export const EmployeeTest: ActivityComponent<{ employeeId: string }> = ({ employeeId }) => {
  const { data, loading, error } = useQuery(PlaygroundEmployeeTestActivityDocument, {
    variables: {
      id: employeeId,
    },
  })

  const employee = data?.employees.employee

  return (
    <Activity loading={loading} error={error}>
      {employee?.fullName}
    </Activity>
  )
}
